import { ChatMessage } from '../api'
import { Action, AppState } from '../state/AppProvider'

export const handleChatHistoryClick = (
  appStateContext:
    | {
        state: AppState
        dispatch: React.Dispatch<Action>
      }
    | undefined
) => {
  const history = { ...appStateContext?.state.currentChat }
  const filteredHistory = history?.messages?.filter(message => message.role !== 'tool') || []
  download('chat_history', filteredHistory)
}

export const download = (filename: 'chat_history', conversation: ChatMessage[]) => {
  const file = new Blob([JSON.stringify(conversation, null, 2)], { type: 'text/plain' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(file)

  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export const handleHistoryClick = (
  appStateContext:
    | {
        state: AppState
        dispatch: React.Dispatch<Action>
      }
    | undefined
) => {
  appStateContext?.dispatch({ type: 'TOGGLE_CHAT_HISTORY' })
}
